<template>
  <!-- -->
  <div class="classmate-info" style="height: 100%">
    <list-page>
      <list-table background-color="#FFF">
        <form-tag label="班组信息"/>
        <form-items :columns="3" :data="dataDetail">
          <form-item label="班组名称" :required="true" name="classmateName" error-message="请输入班组名称">
            <el-input v-model="dataDetail.classmateName" placeholder="请输入班组名称"/>
          </form-item>
          <form-item label="负责人" :required="true" name="leader" error-message="请选择班组负责人">
            <employee-select v-model="dataDetail.leader"/>
          </form-item>
          <form-item label="施工工地" :required="true" name="siteId" error-message="请选择施工工地">
            <c-custom-select value="id" label="siteName" :data-list="siteList" v-model="dataDetail.siteId" placeholder="请选择工地" @change="changeSiteId"/>
          </form-item>
          <form-item label="标段" :required="true" name="lot" error-message="请填写标段信息">
            <c-custom-select value="dictCode" label="dictName" :data-list="lotList" v-model="dataDetail.lot" />
          </form-item>
          <form-item label="考勤配置">
            <el-select v-model="dataDetail.attendConfigId">
              <el-option v-for="item in configList" :key="item.id" :value="item.id" :label="item.configName"/>
            </el-select>
          </form-item>
        </form-items>
        <form-tag label="公司信息"/>
        <form-items :data="dataDetail">
          <form-item label="公司名称">
            <el-input v-model="dataDetail.companyName" placeholder="请输入公司名称"/>
          </form-item>

          <form-item label="注册时间">
            <yq-date-picker style="width: 100%" v-model="dataDetail.registerTime" placeholder="请选择注册时间"/>
          </form-item>
          <form-item label="联系电话">
            <el-input v-model="dataDetail.contactPhone" placeholder="请输入联系电话"/>
          </form-item>

          <form-item label="法人代表">
            <el-input v-model="dataDetail.legal" placeholder="请输入法人代表"/>
          </form-item>
          <form-item label="注册地址" :show-block="true">
            <el-input v-model="dataDetail.registerAddr" placeholder="请输入注册地址"/>
          </form-item>
        </form-items>
        <form-tag label="资质信息"/>
        <form-items :data="dataDetail">
          <form-item label="资质证书">
            <el-input v-model="dataDetail.certificateNo" placeholder="请输入资质证书编号"/>
          </form-item>
          <form-item label="安全许可证">
            <el-input v-model="dataDetail.safeLicenseNo" placeholder="请输入安全许可证编号"/>
          </form-item>
          <form-item label="经营许可证">
            <el-input v-model="dataDetail.businessLicenseNo" placeholder="请输入经营许可证编号"/>
          </form-item>
          <form-item label="资质有效期限">
            <yq-date-picker style="width: 100%" v-model="dataDetail.qualificationDate"
                            placeholder="请选择资质有效期限"/>
          </form-item>
        </form-items>

        <form-tag label="资质文件"/>
        <image-upload v-model="dataDetail.qualificationFile" :limit="9"/>

        <form-tag label="劳务人员"/>
        <laborers-table :data="workerList"/>
      </list-table>
      <form-page :show-page="false">
        <page-button type="write" @click="save" el-type="primary">保存</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import {useRoute, useRouter} from "vue-router";
import FormTag from "@/components/h5/layout/FormTag.vue";
import YqDatePicker from "@/components/h5/date/YqDatePicker.vue";
import ImageUpload from "@/components/h5/image/ImageUpload.vue";
import LaborersTable from "@/views/h5/luqiao/display/LaborersTable.vue";
import classmateApi from "@/api/dz-luqiao/luqiaoClassmateApi";
import commonLqApi from "@/api/dz-luqiao/luqiaoCommonApi";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import commonApi from "@/api/commonApi";
import util from "@/util/util";
import CCustomSelect from "@/views/h5/luqiao/display/c-custom-select.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "ClassmateDetail",
  components: {
    EmployeeSelect, CCustomSelect,
    ImageUpload,
    YqDatePicker,
    PageButton, ListPage, ListTable, FormPage, FormItems, FormItem, FormTag, LaborersTable
  },
  data() {
    return {
      dataDetail: {
        classmateName: '',      // 班组名称
        leader: '',             // 负责人
        siteId: '',             // 施工工地
        companyName: '',        // 公司名称
        registerTime: '',       // 注册时间
        contactPhone: '',       // 联系电话
        legal: '',              // 法人代表
        registerAddr: '',       // 注册地址
        certificateNo: '',      // 资质证书编号
        safeLicenseNo: '',      // 安全许可证编号
        businessLicenseNo: '',  // 经营许可证编号
        qualificationDate: '',  // 资质有效期限
        qualificationFile: '',  // 资质文件
        laborers: []            // 劳务人员
      },
      siteList: [],
      workerList: [],
      lotList: [],  // 标段信息
      configList: [],
    };
  },
  async created() {
    await this.init();
    this.configList = await classmateApi.queryAllAttendConfig()
  },
  methods: {
    async save(){
      this.dataDetail = await classmateApi.saveSubmit(this.dataDetail)
    },
    async init(){
      // 工地列表
      this.siteList = await commonLqApi.querySiteNoPage()
      // 标段
      this.lotList = await commonApi.queryDictionaryList("LOT", (await util.getUserInfo()).merchantId)
      // 是否为编辑
      if(this.route.query.id){
        await this.findById(this.route.query.id)
        // 查询劳务人员
        this.workerList = await classmateApi.queryWorkersByClassmateId(this.route.query.id)
      }
    },
    async findById(id){
      this.dataDetail = await classmateApi.findById(id);
    },
    // 变更工地信息
    changeSiteId() {
      if (this.dataDetail.siteId) {
        // 项目变更,如果已保存考勤，不变更
        if (this.dataDetail.attendConfigId && this.dataDetail.id) {
          // 已保存，有id，且有考勤数据
          return;
        }
        // 项目信息
        for (let i = 0; i < this.siteList.length; i++) {
          if (this.siteList[i].id === this.dataDetail.siteId) {
            if (!this.siteList[i].attendConfigId) {
              // 没有考勤
              return;
            }
            this.dataDetail.attendConfigId = this.siteList[i].attendConfigId;
            break;
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.classmate-info{
  height: 100%;
  .list-page{
    >.list-table{
      padding: 10px;
      display: flex;
      flex-direction: column;
      .list-table{
        flex: 1;
        height: 100px;
      }
    }
  }
}
:deep(.yq-table){
  .el-table{
    position: relative;
  }
}
</style>